import axios from "axios";
import { authHeaderJson, authHeaderTextPlain } from "../auth-header.service";
import moment from "moment";
import { getLocalClientTimeZone, isNullUndefinedOrEmpty } from "../../common/Helpers";

const getCheckPayConfigurationExists = (elementId) => {
    return axios.get(`/api/payconfig/configuracion/exists/${elementId}`, { headers: authHeaderJson() } );
};

const getPayConfiguration = (elementId) => {
    return axios.get(`/api/payconfig/configuracion/get/${elementId}`, { headers: authHeaderJson() } );
};

const addPayConfigurationBase = (elementId) => {
    return axios.post(`/api/payconfig/configuracion/create/${elementId}`, { headers: authHeaderTextPlain() } );
};

const updatePayConfiguration = (item) => {
    return axios.put(`/api/payconfig/configuracion/update`, item, { headers: authHeaderTextPlain() } );
};


const addEdpPartiGroup = (elementId, item) => {
    return axios.put(`/api/payconfig/configuracion/group/add/${elementId}`, item, { headers: authHeaderJson() } )
};

const deleteEdpPartiGroup = (elementId, groupId) => {
    //[##PATH ROUTE##]
    return axios.delete(`/api/payconfig/configuracion/group/delete/${elementId}/${groupId}`, { headers: authHeaderJson() });
};

const validateContractRolesToEdP = (elementId) => {
    return axios.get(`/api/Privilege/privilegepartymemberselement/hasrol/${elementId}`, { headers: authHeaderJson() } );
};

const validateContractEdPOnPreparation = (elementId) => {
    return axios.get(`/api/Pay/edp/existspreparacion/${elementId}`, { headers: authHeaderJson() } );
};

const getValidateModificacionPartidas = (elementId) => {
    return axios.post(`/api/Partida/set/validate/modificacionpartidas/${elementId}`, { headers: authHeaderJson() } );
};

const getValidatePartidasAbiertas = (elementId) => {
    return axios.get(`/api/Partida/validate/partidasabierta/${elementId}`, { headers: authHeaderJson() } );
};

const getEdPPrepare_ResultList = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/get/${elementId}/${edpId}`, { headers: authHeaderJson() } );
};

const getEdPPrepare_DIList = (edpId) => {
    return axios.get(`/api/Pay/edp/get/listdi/${edpId}`, { headers: authHeaderJson() } );
};

const getEdPPrepare_PartiesList = (edpId, calcular_factores, crear_definicion_polinomio) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/get/listpartidas/${edpId}/${calcular_factores === true ? 1 : 0}/${crear_definicion_polinomio === true ? 1 : 0}`, { headers: authHeaderJson() } );
};

const getEdPPDF_PolinomioList = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/pdf/polinomio/${elementId}/${edpId}`, { headers: authHeaderJson() } );
};

const deleteEdP = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.delete(`/api/Pay/edp/delete/${elementId}/${edpId}`, { headers: authHeaderJson() });
};

const anulateEdP = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Pay/edp/anulate/${elementId}/${edpId}`, { headers: authHeaderJson() });
};

const exportEdP = (elementId, edpId) => {
    //[##PATH ROUTE##]
    const timeOffset = getLocalClientTimeZone();
    
    return axios.get(`/api/Pay/edp/excel/${elementId}/${edpId}/${timeOffset}`, { headers: authHeaderJson() });
};


const revisionEP = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Pay/edp/revision/${elementId}/${edpId}`, { headers: authHeaderTextPlain() });
};

const revisionEndsEP = (elementId, edpId, tipoRespuesta) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Pay/edp/revisionends/${elementId}/${edpId}/${tipoRespuesta}`, { headers: authHeaderTextPlain() });
};

const getHeaderEP = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/get/header/${elementId}/${edpId}`, { headers: authHeaderJson() } );
};

const getChecklistEP = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/get/checklist/${elementId}/${edpId}`, { headers: authHeaderJson() } );
};

const Obtener_Ambiente_EP = (edpId) => {
    return axios.get(`/api/Pay/edp/get/variablesambiente/${edpId}`, { headers: authHeaderJson() } );
};

const generateNewEdp = (elementId, endDate) => {
    //[##PATH ROUTE##]
    let qs_periodEndsDate = endDate !== null && endDate !== undefined ? `?dt_fecha_hasta_seleccionada=${encodeURIComponent(moment(endDate).format('MM/DD/YYYY'))}` : '';
    return axios.post(`/api/Pay/edp/generate/${elementId}${qs_periodEndsDate}`, { headers: authHeaderJson() } );
};

const Validar_Guardado_EP = (data) => {
    return axios.post(`/api/Pay/edp/set/list`, data,{ headers: authHeaderJson() } );
};

const getCommentListEP = (edpId, edpPartidaId, edpIncrementoId, edpDeduccionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/mensaje/get/${edpId}/${isNullUndefinedOrEmpty(edpPartidaId) ? 0 : edpPartidaId}/${isNullUndefinedOrEmpty(edpIncrementoId) ? 0 : edpIncrementoId}/${isNullUndefinedOrEmpty(edpDeduccionId) ? 0 : edpDeduccionId}/list`, { headers: authHeaderJson() } );
};

const setCommentEdP = (elementId, data) => {
    return axios.post(`/api/Pay/edp/mensaje/set/${elementId}`, data,{ headers: authHeaderJson() } );
};

const getTiposNotaChecklistEP = () => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/checklist/nota/tipo/list`, { headers: authHeaderJson() } );
};

const getNotasChecklistEP = (elementId, edpId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Pay/edp/checklist/nota/get/${elementId}/${edpId}/list`, { headers: authHeaderJson() } );
};

const setTipoNotaChecklistEP = (item) => {
    return axios.post(`/api/Pay/edp/checklist/nota/tipo/add`, item, { headers: authHeaderJson() } );
};

const updateTipoNotaChecklistEP = (id, item) => {
    return axios.put(`/api/Pay/edp/checklist/nota/tipo/update/${id}`, item, { headers: authHeaderJson() });
};

const deleteTipoNotaChecklistEP = (id) => {
    return axios.delete(`/api/Pay/edp/checklist/nota/tipo/delete/${id}`, { headers: authHeaderJson() });
};

const getCheckIfNewEdpDateNeeded = (elementId) => {
    return axios.get(`/api/Pay/edp/get/needenddate/${elementId}`, { headers: authHeaderJson() } );
};

const downloadDocumentsByIds = (documentIdList) => {
    return axios.post(`/api/Pay/edp/documents`, documentIdList, { headers: authHeaderJson() } )
};

const deleteDocumentsByIds = (documentIdList) => {
    return axios.post(`/api/Pay/edp/documents/delete`, documentIdList, { headers: authHeaderJson() } )
};

const setRevisionEdP = (data) => {
    return axios.post(`/api/Pay/edp/set/revision`, data,{ headers: authHeaderJson() } );
};

const setRevisionEdPv2 = (data) => {
    return axios.post(`/api/Pay/edp/set/revision/v2`, data,{ headers: authHeaderJson() } );
};

const getRevisionEP = (elementId, edpId, partidaId, diId, rol, epIteracion, edpIatrizEtapaId, tipoRespuestaId) => {
    //[##PATH ROUTE##]
    let qs_edpId = edpId !== null ? `?ep_id=${edpId}` : '';
    let qs_diId = diId !== null ? `&di_id=${diId}` : '';

    return axios.get(`/api/Pay/edp/get/revision/${elementId}/${edpId}/${isNullUndefinedOrEmpty(partidaId) ? 0 : partidaId}/${rol}/${epIteracion}/${edpIatrizEtapaId}/${tipoRespuestaId}${qs_edpId}${qs_diId}`, { headers: authHeaderJson() } );
};


export {
    getCheckPayConfigurationExists,
    getPayConfiguration,
    addPayConfigurationBase,
    updatePayConfiguration,
    validateContractRolesToEdP,
    addEdpPartiGroup,
    deleteEdpPartiGroup,
    validateContractEdPOnPreparation,
    getValidateModificacionPartidas,
    getValidatePartidasAbiertas,
    getEdPPrepare_ResultList,
    getEdPPrepare_DIList,
    getEdPPrepare_PartiesList,
    getEdPPDF_PolinomioList,
    deleteEdP,
    anulateEdP,
    exportEdP,
    revisionEndsEP,
    revisionEP,
    Obtener_Ambiente_EP,
    Validar_Guardado_EP,
    generateNewEdp,
    getHeaderEP,
    getChecklistEP,
    getCommentListEP,
    setCommentEdP,
    getTiposNotaChecklistEP,
    getNotasChecklistEP,
    setTipoNotaChecklistEP,
    updateTipoNotaChecklistEP,
    deleteTipoNotaChecklistEP,
    getCheckIfNewEdpDateNeeded,
    setRevisionEdP,
    setRevisionEdPv2,
    getRevisionEP,
    downloadDocumentsByIds,
    deleteDocumentsByIds
}